:host {
  display: inline-block;
}

.sidebar {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  inline-size: var(--sidebar-container-inline-size);
  background-color: var(--sidebar-container-background);
  border: var(--sidebar-container-border-width) solid var(--sidebar-container-border-color);
  border-radius: var(--sidebar-container-border-radius);
  overflow: hidden;
}

:host([collapsed]) .sidebar {
  inline-size: var(--sidebar-container-collapsed-inline-size);
}
